import './GradientLegend.scss';
import cn from 'classnames';
import { formatNumber } from '@blisspointmedia/bpm-types/dist/formatUtils';

interface GradientLegendProps {
  title?: string;
  bins: number[];
  useConvergent: boolean;
  legendStyle?: {
    background: string;
  };
  formatLabel?: (val: number) => string;
  reverse?: boolean;
}

interface LegendTickProps {
  value: number;
  index: number;
  totalCount: number;
  hasInvalidData: boolean;
  formatLabel: (val: number) => string;
}

const LegendTick = ({ value, index, totalCount, hasInvalidData, formatLabel }: LegendTickProps) => {
  const basePercentage = (index / (totalCount - 1)) * 100;
  let left = basePercentage;
  if (index === 0) {
    left += 0.1;
  } else if (index === totalCount - 1) {
    left -= 0.1;
  }

  return (
    <div className='legend-tick-box' style={{ left: `${left}%` }}>
      <div className='legend-tick-line' />
      {!hasInvalidData && <div className='legend-tick-text'>{formatLabel(value)}</div>}
    </div>
  );
};

export const GradientLegend = ({
  title,
  bins,
  useConvergent = true,
  legendStyle,
  formatLabel = val => formatNumber(val, 2),
  reverse
}: GradientLegendProps) => {
  const binsToUse = reverse ? [...bins].reverse() : bins;
  const hasInvalidData = binsToUse.some(value => Number.isNaN(value) || !Number.isFinite(value));

  return (
    <div className='gradient-legend'>
      {title && <div className='legend-title'>{title}</div>}
      <div className='legend-contents-box'>
        <div className='legend-contents'>
          <div
            className={cn(
              'rectangle',
              !legendStyle && (useConvergent ? 'convergent' : 'divergent')
            )}
            style={legendStyle}
          />
          <div className='legend-tick-container'>
            {binsToUse.map((value, index) => (
              <LegendTick
                key={index}
                value={value}
                index={index}
                totalCount={binsToUse.length}
                hasInvalidData={hasInvalidData}
                formatLabel={formatLabel}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
